import React from "react";
import HeroSection from "../../components/heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";

export default function Navbar() {
  return (
    <>
      {/* <HeroSection
        backgroundImage={heroPhoto}
        title="Order Today, Delivered Today"
        titleHighlight="Delivered Today"
        features={[
          "Direct transport to the customer",
          "Pickup in Cologne in 90 minutes",
          "Real-time shipment tracking",
          "Fair prices – no hidden costs",
          "Available across Germany & Europe",
          "Your shipment is insured",
          "Local & long-distance transport",
        ]}
        showQuoteForm={true}
        customHeight="150vh"
      /> */}

      {/* باقي أقسام الصفحة */}
    </>
  );
}
